import apiClient from "../helper/apiClient";
import { validateUserKey } from "./validateUserKey";

export default async function editFileById(fileid, newSentences, isMeddic, userKey) {
  validateUserKey(userKey);
  try {
    let userEmail = localStorage.getItem("user") ? localStorage.getItem("user") : sessionStorage.getItem("user");
    const { data } = await apiClient.put(`api/edit/file/${fileid}`, {
      fileId: fileid,
      sentences: newSentences,
      user_email: userEmail,
      isMeddic,
      userKey,
    });
    return data;
  } catch (err) {
    throw new Error(err.message || err);
  }
}
